import React from 'react';
import PropTypes from 'prop-types';
import { VictoryBar, VictoryChart, VictoryAxis } from 'victory';
import { graphXaxisFormatter } from '../../../utils/formatter';
import { computeYAxisTickCount } from '../../../utils/chart-utils';

const X_AXIS_CONFIG = {
    style: {
        axis: { stroke: '#FFF' },
        ticks: { stroke: '#000', size: 5 },
        tickLabels: {
            fontSize: 16,
            fontFamily: 'inherit',
            padding: 5,
        },
    },
    tickFormat: graphXaxisFormatter(4),
};

const Y_AXIS_CONFIG = {
    dependentAxis: true,
    minDomain: { x: 0 },
    style: {
        axis: { stroke: '#000' },
        ticks: { stroke: '#000', size: 5 },
        grid: {
            stroke: 'rgb(216, 215, 215)',
            strokeDasharray: '5px, 5px',
        },
        tickLabels: {
            fontSize: 16,
            fontFamily: 'inherit',
            padding: 5,
        },
    },
    tickFormat: (yValue) => (Number.isInteger(yValue) ? yValue.toString() : ''),
};

const BAR_CHART_CONFIG = {
    style: { data: { fill: '#B6F0FF' } },
    barRatio: 0.8,
    y0: 0,
};

export default function BarChart({ data, x, y, width }) {
    return (
        <VictoryChart
            domainPadding={20}
            height={300}
            style={{ parent: { margin: 0 } }}
            width={width}
        >
            <VictoryAxis {...X_AXIS_CONFIG} />
            <VictoryAxis
                tickCount={computeYAxisTickCount(data, y)}
                {...Y_AXIS_CONFIG}
            />
            <VictoryBar data={data} x={x} y={y} {...BAR_CHART_CONFIG} />
        </VictoryChart>
    );
}

BarChart.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object).isRequired,
    width: PropTypes.number.isRequired,
    x: PropTypes.string.isRequired,
    y: PropTypes.string.isRequired,
};
